"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMobileAuthLink = exports.openAuthToFollowSave = exports.openAuthModal = void 0;

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.function.name");

var _cohesion = require("@artsy/cohesion");

var _Types = require("../Components/Authentication/Types");

var _qs = _interopRequireDefault(require("qs"));

var _sharify = require("sharify");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var openAuthModal = function openAuthModal(mediator, options) {
  mediator.trigger("open:auth", options);
};

exports.openAuthModal = openAuthModal;

var openAuthToFollowSave = function openAuthToFollowSave(mediator, options) {
  var handled = false;

  if (_sharify.data.IS_MOBILE) {
    var intent = getMobileIntent(options);

    if (intent) {
      openMobileAuth(intent);
      handled = true;
    }
  } else if (mediator) {
    var _intent = getDesktopIntent(options);

    if (_intent) {
      openAuthModal(mediator, _objectSpread({
        mode: _Types.ModalType.signup
      }, _intent));
      handled = true;
    }
  }

  if (!handled) {
    window.location.assign("/login");
  }
};

exports.openAuthToFollowSave = openAuthToFollowSave;

var getMobileAuthLink = function getMobileAuthLink(mode, options) {
  var path = mode === "login" ? "log_in" : "sign_up";
  return "/".concat(path, "?").concat(_qs.default.stringify(options));
};

exports.getMobileAuthLink = getMobileAuthLink;

function openMobileAuth(intent) {
  var href = getMobileAuthLink(_Types.ModalType.signup, _objectSpread({
    redirectTo: window.location.href
  }, intent));
  window.location.assign(href);
}

function getMobileIntent(options) {
  switch (options.intent) {
    case _cohesion.Intent.followArtist:
    case _cohesion.Intent.followPartner:
      return getMobileIntentToFollow(options);

    case _cohesion.Intent.saveArtwork:
      return getMobileIntentToSaveArtwork(options);

    default:
      return undefined;
  }
}

function getMobileIntentToFollow(_ref) {
  var contextModule = _ref.contextModule,
      entity = _ref.entity,
      intent = _ref.intent;
  var kind = intent === _cohesion.Intent.followArtist ? "artist" : "profile";
  return {
    action: "follow",
    contextModule: contextModule,
    copy: "Sign up to follow ".concat(entity.name),
    intent: intent,
    kind: kind,
    objectId: entity.slug
  };
}

function getMobileIntentToSaveArtwork(_ref2) {
  var contextModule = _ref2.contextModule,
      entity = _ref2.entity,
      intent = _ref2.intent;
  return {
    action: "save",
    contextModule: contextModule,
    copy: "Sign up to save artworks",
    intent: intent,
    kind: "artworks",
    objectId: entity.slug
  };
}

function getDesktopIntentToFollow(_ref3) {
  var contextModule = _ref3.contextModule,
      entity = _ref3.entity,
      intent = _ref3.intent;
  var kind = intent === _cohesion.Intent.followArtist ? "artist" : "profile";
  return {
    mode: _Types.ModalType.signup,
    contextModule: contextModule,
    copy: "Sign up to follow ".concat(entity.name),
    intent: intent,
    afterSignUpAction: {
      action: "follow",
      kind: kind,
      objectId: entity.slug
    }
  };
}

function getDesktopIntentToSaveArtwork(_ref4) {
  var contextModule = _ref4.contextModule,
      entity = _ref4.entity,
      intent = _ref4.intent;
  return {
    mode: _Types.ModalType.signup,
    contextModule: contextModule,
    copy: "Sign up to save artworks",
    intent: intent,
    afterSignUpAction: {
      action: "save",
      kind: "artworks",
      objectId: entity.slug
    }
  };
}

function getDesktopIntent(options) {
  switch (options.intent) {
    case _cohesion.Intent.followArtist:
    case _cohesion.Intent.followPartner:
      return getDesktopIntentToFollow(options);

    case _cohesion.Intent.saveArtwork:
      return getDesktopIntentToSaveArtwork(options);

    default:
      return undefined;
  }
}
//# sourceMappingURL=openAuthModal.js.map